import React from 'react';

export function ClockIcon({ className }: Readonly<{ className?: string }>) {
  return (
    <svg
      className={className}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M7.47433 14.3087C10.8132 14.3087 13.52 11.6019 13.52 8.263C13.52 4.92404 10.8132 2.21729 7.47433 2.21729C4.13537 2.21729 1.42862 4.92404 1.42862 8.263C1.42862 11.6019 4.13537 14.3087 7.47433 14.3087Z"
        stroke="currentColor"
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.47433 5.10876V8.26305H10.1029"
        stroke="currentColor"
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0349 0.640137C12.3456 1.25338 13.472 2.19468 14.3086 3.35837"
        stroke="currentColor"
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.91373 0.640259C2.60309 1.2535 1.47664 2.19481 0.640045 3.3585"
        stroke="currentColor"
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
